module.exports = __webpack_public_path__ + "static/media/deloitte-logo.621cc45f.png";